import { SidebarOpenMode } from '../detailsSidebar.interface';

export const toggleViewEditMode = (mode: SidebarOpenMode) => {
  switch (mode) {
    case SidebarOpenMode.View: return SidebarOpenMode.Edit;
    case SidebarOpenMode.Edit: return SidebarOpenMode.View;
    default: return mode;
  }
};
